import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// Packages
import { Button, Col, Flex, Row, Typography  } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import UsersForm from './UsersForm';
import UsersTable from './UsersTable';

// Actions
import { get_all_users } from '../../../redux/actions/usersActions';

const Users = (props) => {
	const { messageApi } = props;

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [update, setUpdate] = useState(false);
	const [userToUpdate, setUserToUpdate] = useState({});
	const [pageSize, setPageSize] = useState(10);
	const [skip, setSkip] = useState(0);

	useEffect(() => {
		const savedSkip = parseInt(localStorage.getItem('usersSkip')) || 0;
		setSkip(savedSkip);

		const savedPageSize = parseInt(localStorage.getItem('usersPageSize')) || 10;
		setPageSize(savedPageSize);

		const filters = { skip: savedSkip, limit: savedPageSize };
		dispatch(get_all_users(filters));
	}, []);

	const handleAdd = () => {
		setIsModalOpen(true);
		setUpdate(false);
		setUserToUpdate({});
	}

	return (
		<div>
			<UsersForm
				messageApi={messageApi}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				update={update}
				userToUpdate={userToUpdate}
				setUserToUpdate={setUserToUpdate}
				filters={{ skip: skip, limit: pageSize }}
			/>

			<Row>
				<Col xs={24} sm={18} md={18} lg={18} xl={18}>
					<Typography.Title>{t('menuItems.users')}</Typography.Title>
				</Col>
				<Col xs={24} sm={6} md={6} lg={6} xl={6}>
					<Flex align='center' justify='flex-end' style={{ height: '100%' }}>
						<Button
							type='primary'
							size='large'
							onClick={handleAdd}
						>
							{t('buttons.create')}
						</Button>
					</Flex>
				</Col>
			</Row>

			<UsersTable
				messageApi={messageApi}
				setIsModalOpen={setIsModalOpen}
				setUpdate={setUpdate}
				setUserToUpdate={setUserToUpdate}
				pageSize={pageSize}
				setPageSize={setPageSize}
				skip={skip}
				setSkip={setSkip}
			/>
		</div>
	)
}

Users.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default Users;
